import { ApiAction, PaginatedApiState, initialPaginatedApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';
import Preorder from '../../models/Preorder';

export interface PreorderCtrlListState extends PaginatedApiState {
  preorders?: Preorder[]
}

const PreorderList = (state: PreorderCtrlListState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<PreorderCtrlListState>('PREORDER_CTRL_LIST')(state, action)
  }
}

export default PreorderList